module.exports = __webpack_public_path__ + "media/images/紹介割引_1000円_1280_480-b793d9c86fe86db49d7e4d31b8d9acc6.png";